import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY || '');

export const StripeContext = ({ children }: { children: JSX.Element }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
